import Image from 'next/image';
import { ComponentPropsWithRef, forwardRef } from 'react';
import { cx, __DEV__, externalUrl } from '../../utils';
import styles from './mosaic.module.scss';

interface CustomMosaicProps {
  items: string[];
  objectFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
  onItemSelected?: (idx: number) => void;
}

export interface MosaicProps
  extends ComponentPropsWithRef<'div'>,
    CustomMosaicProps {}

const Mosaic = forwardRef<HTMLDivElement, MosaicProps>((props, ref) => {
  const { items = [], objectFit = 'cover', onItemSelected, ...rest } = props;

  const handleItemSelected = (index: number) => {
    onItemSelected?.(index);
  };

  const images = items.map((image, index) => {
    const classes = cx('mosaic-item', styles[`mosaic-item--${index + 1}`]);

    return (
      <div
        key={index}
        className={classes}
        onClick={() => handleItemSelected(index)}
      >
        {/* FIXME: Add an alt from the image? */}
        <Image src={image} alt="image" layout="fill" objectFit={objectFit} loader={externalUrl} />
      </div>
    );
  });

  return (
    <div ref={ref} className={styles['parent']} {...rest}>
      {images}
    </div>
  );
});

if (__DEV__) {
  Mosaic.displayName = 'Mosaic';
}

export { Mosaic };
